<script>
import matchEntity from './MatchEntity.vue';

export default {
  name: 'round-match',

  props: [
    'competitionID',
    'competition_type',
    'rounds',
    'round',
    'results',
    'match',
    'applications',
    'overview',
    'delegated_progression',
  ],

  data() {
    return {
      isBlank: false,
    }
  },

  components: {
    matchEntity,
  },

  template: `
    <div v-bind:class="{'is-blank': isBlank, 'is-scrollable': true}">
      <a :id="match.key" :href="'match/' + match.key" :class="'competition-type-' + competition_type | sanitizeAttr">
        <div v-bind:class="{'match-details': true, 'all-details': competition_type == 'round robin'}">
          <div v-if="match.start_time" class="match-time">
            <div>{{match.start_time | formatTime}}</div>
          </div>
          <div v-if="match.date && competition_type == 'round robbin'" class="match-date">{{ match.date | formatDate }}</div>
          <div v-else class="match-date">{{round.date | formatDate}}</div>
          <div class="match-position">Match {{ match.position }}</div>
          <div v-if="match.facility" class="match-location">
            <span v-if="match.facility.venue_title">{{match.facility.venue_title}}</span>
            <span v-if="match.facility.title">{{match.facility.title}}</span>
          </div>
        </div>
        <div class="match-entities">
          <match-entity
            :entity="match.entityA"
            :rounds="rounds"
            :results="results"
            :applications="applications"
            :match="match"
            :isEntityA="true"
            :isHome="match.entityA_home"
            :delegated_progression="delegated_progression"
            :competition_type="competition_type"
            class="is-first">
          </match-entity>
          <div class="verse"><i class="fa-solid fa-v"></i></div>
          <match-entity
              :entity="match.entityB"
              :rounds="rounds"
              :results="results"
              :applications="applications"
              :match="match"
              :isEntityA="false"
              :delegated_progression="delegated_progression"
              :isHome="match.entityB_home"
              :competition_type="competition_type">
          </match-entity>
        </div>
      </a>
    </div>
  `,

  mounted() {
    if(this.match && this.match.entityA.blank && this.match.entityB.blank) this.isBlank = true; 
  }
}
</script>

<style scoped>
</style>
